import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import ConstructionIcon from "@mui/icons-material/Construction";
import CategoryIcon from "@mui/icons-material/Category";

export const AdminDashboard: React.FunctionComponent = () => {
  return (
    <>
      <Grid container spacing={3} display={"flex"} alignItems={"flex-end"}>
        <Grid item md={3} xs={12}>
          <Card sx={{ height: "100%" }}>
            <CardContent>
              <Grid
                container
                spacing={3}
                sx={{ justifyContent: "space-between" }}
              >
                <Grid item>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="overline"
                  >
                    TOTAL WHOLEGOODS
                  </Typography>
                  <Typography color="textPrimary" variant="h4">
                    0
                  </Typography>
                </Grid>
                <Grid item>
                  <Avatar
                    sx={{
                      backgroundColor: "error.main",
                      height: 56,
                      width: 56,
                    }}
                  >
                    <PrecisionManufacturingIcon />
                  </Avatar>
                </Grid>
              </Grid>
              <Box
                sx={{
                  pt: 2,
                  display: "flex",
                  alignItems: "baseline",
                }}
              >
                <Typography
                  sx={{
                    mr: 1,
                  }}
                  variant="body2"
                >
                  0
                </Typography>
                <Typography color="textSecondary" variant="caption">
                  Synced
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={3} xs={12}>
          <Card>
            <CardContent>
              <Grid
                container
                spacing={3}
                sx={{ justifyContent: "space-between" }}
              >
                <Grid item>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="overline"
                  >
                    TOTAL PARTS
                  </Typography>
                  <Typography color="textPrimary" variant="h4">
                    0
                  </Typography>
                </Grid>
                <Grid item>
                  <Avatar
                    sx={{
                      backgroundColor: "success.main",
                      height: 56,
                      width: 56,
                    }}
                  >
                    <ConstructionIcon />
                  </Avatar>
                </Grid>
              </Grid>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  pt: 2,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    mr: 1,
                  }}
                >
                  0
                </Typography>
                <Typography color="textSecondary" variant="caption">
                  Synced
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={3} xs={12}>
          <Card>
            <CardContent>
              <Grid
                container
                spacing={3}
                sx={{ justifyContent: "space-between" }}
              >
                <Grid item>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="overline"
                  >
                    TOTAL CATEGORIES
                  </Typography>
                  <Typography color="textPrimary" variant="h4">
                    0
                  </Typography>
                </Grid>
                <Grid item>
                  <Avatar
                    sx={{
                      backgroundColor: "success.main",
                      height: 56,
                      width: 56,
                    }}
                  >
                    <CategoryIcon />
                  </Avatar>
                </Grid>
              </Grid>
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  mt: 2,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    mr: 1,
                  }}
                ></Typography>
                <Typography color="textSecondary" variant="caption">
                  All Type Categories
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={3} xs={12}>
          <Card>
            <CardContent>
              <Grid
                container
                spacing={3}
                sx={{ justifyContent: "space-between" }}
              >
                <Grid item>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="overline"
                  >
                    TOTAL MANUFACTURERS
                  </Typography>
                  <Typography color="textPrimary" variant="h4">
                    0
                  </Typography>
                </Grid>
                <Grid item>
                  <Avatar
                    sx={{
                      backgroundColor: "success.main",
                      height: 56,
                      width: 56,
                    }}
                  >
                    <PrecisionManufacturingIcon />
                  </Avatar>
                </Grid>
              </Grid>
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  mt: 2,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    mr: 1,
                  }}
                ></Typography>
                <Typography color="textSecondary" variant="caption">
                  All Type Manufacturers
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};
